import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { formatCurrency2Digit } from "utils/helpers/format";
const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    // {
    //   Header: "",
    //   accessor: "checkbox",
    //   width: "50px",
    //   disableSortBy: true,
    //   Cell: ({ row }) => (
    //     <Checkbox
    //       checked={selected[row.values.id] || false}
    //       onChange={() => handleCheckboxChange(row.values.id)}
    //     />
    //   ),
    // },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสสินค้า", accessor: "product_code" },
    { Header: "ชื่อสินค้า", accessor: "product_name" },
    { Header: "จำนวน", accessor: "total_amount" },
    {
      Header: "ราคาทุน/ชิ้น",
      accessor: "price",
      Cell: ({ row }) => {
        return <span>{formatCurrency2Digit(row?.price || 0)}</span>;
      },
    },
    {
      Header: "ราคาขาย/ชิ้น",
      accessor: "sell_price",
      Cell: ({ row }) => {
        return (
          <span>
            {row?.sell_price ? formatCurrency2Digit(row?.sell_price || 0) : "-"}
          </span>
        );
      },
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          {console.log("display row id", row)}
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                setViewProduct(row);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("row", row);
                setProduct(row);
                handleModalOpen();
                handleMenuClose();
              }}
            >
              <BorderColorIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>แก้ไข</span>
            </MenuItem>
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
